import React, { Component } from 'react';
import Slider from 'react-slick';
import ReactSVG from 'react-svg';
import { Link } from 'react-router-dom';
// import { TweenLite } from 'gsap/TweenMax';

const settings = {
    slidesToShow: 1,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 500,
    fade: true,
    cssEase: 'linear'
}

class _Slider extends Component {
    render() {
        return(
            <div className="slider">
                <Slider
                    {...settings}
                >
                    <div className="slide slide--clock">
                        <div className="container">
                            <div className="slide__content">
                                <ReactSVG
                                    src={'/img/clock.svg'}
                                    svgClassName={'slide__icon slide__icon--left'}
                                />
                                <p className="slide__text">Make time to develop your skills and grow your business</p>
                            </div>
                        </div>
                    </div>

                    <div className="slide slide--community slide--icon-right">
                        <div className="container">
                            <div className="slide__content">
                                <ReactSVG
                                    src={'/img/doers.svg'}
                                    svgClassName={'slide__icon'}
                                />
                                <p className="slide__text">Startup Club is a place to learn from other founders</p>
                            </div>
                        </div>
                    </div>

                    <div className="slide slide--icon-right">
                        <div className="container">
                            <div className="slide__content">
                                <ReactSVG
                                    src={'/img/founders.svg'}
                                    svgClassName={'slide__icon'}
                                />
                                <p className="slide__text">We have free online workshops every lunchtime</p>
                            </div>
                        </div>
                    </div>

                    <div className="slide slide--icon-right">
                        <div className="container">
                            <div className="slide__content">
                                <ReactSVG
                                    src={'/img/support.svg'}
                                    svgClassName={'slide__icon'}
                                />
                                <p className="slide__text">Join our community for support &amp; advice</p>
                            </div>
                        </div>
                    </div>

                    <div className="slide slide--icon-right">
                        <div className="container">
                            <div className="slide__content">
                                <ReactSVG
                                    src={'/img/stories.svg'}
                                    svgClassName={'slide__icon'}
                                />
                                <p className="slide__text">Sign up to be the first to hear exclusive stories</p>
                            </div>
                        </div>
                    </div>

                    <div className="slide slide--center">
                        <div className="container">
                            <div className="slide__content">
                                <img src="/img/welcome-img.png" alt="Welcome to Startup Club"/>
                            </div>
                        </div>
                    </div>
                </Slider>

                <Link
                    to={'/sign-up'}
                    className={'bttn bttn--rounded bttn--hollow'}
                >Sign up</Link>
            </div>
        );
    }
}

export default _Slider;


// WEBPACK FOOTER //
// ./src/js/components/Slider.js